import { Plot } from '../../core/plot';
import { deepAssign } from '../../utils';
/**
 * 默认配置项
 */
export var DEFAULT_OPTIONS = deepAssign({}, Plot.DefaultOptions, {
    source: {
        data: { type: 'FeatureCollection', features: [] },
        parser: {
            type: 'geojson',
        },
    },
});
//# sourceMappingURL=constants.js.map